import React, { useState, useEffect, useRef } from "react";

function ProgressBar() {
    const [completed, setCompleted] = useState(0);
    const intervalRef = useRef(null);

    const complState = () => {
        const value = Number.parseInt(completed);
        if (value >= 25 && value < 50) {
            return "Optimizing results...";
        } else if (value > 0 && value < 25) {
            return "Requesting details...";
        } else if (value >= 50 && value < 100) {
            return "Processing data...";
        }
        return "";
    };

    useEffect(() => {
        intervalRef.current = setInterval(() => {
            setCompleted((c) => {
                if (c >= 95) {
                    clearInterval(intervalRef.current);
                    return c;
                }
                return c + 0.25;
            });
        }, 30);

        return () => {
            clearInterval(intervalRef.current);
        };
    }, []);

    return (
        <div className="progress-bar-container">
            <div className="d-flex flex-column">
                <div className="progress-text">{complState()}</div>

                <div className="d-flex align-items-center">
                    <div className="flex-1"></div>
                    <i
                        className="fa-solid fa-laptop"
                        style={{
                            fontSize: 31,
                            marginRight: 50,
                        }}
                    ></i>

                    <div className="progress-container">
                        <div
                            style={{ width: `${completed}%` }}
                            className="progress-filler"
                        ></div>
                    </div>

                    <i
                        className="fa-solid fa-cloud"
                        style={{
                            fontSize: 31,
                            marginLeft: 50,
                        }}
                    ></i>

                    <div className="flex-1"></div>
                </div>
            </div>
        </div>
    );
}

export default ProgressBar;
